module.exports = __webpack_public_path__ + "static/img/22.3e2101d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pro/air/22.png
// module id = 11c3
// module chunks = 0